import * as React from 'react'

import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

export interface FixedFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  mobileOnly?: boolean
  className?: string
  contentClassName?: string
  bottomOffset?: number
  fixedHeight?: boolean
}

export const FixedFooter = React.forwardRef<HTMLDivElement, FixedFooterProps>(
  (
    { children, mobileOnly = false, className, contentClassName, fixedHeight = true, bottomOffset = 0, ...props },
    ref,
  ) => {
    const isMobile = useIsMobile()

    if (mobileOnly && !isMobile) {
      return null
    }

    return (
      <div
        ref={ref}
        className={cn(
          'sticky bottom-0 z-20 flex w-full items-center justify-center border-t bg-background p-3',
          fixedHeight && isMobile ? 'h-mobile-footer' : 'h-web-footer',
          className,
        )}
        style={{ bottom: `${bottomOffset}px` }}
        {...props}
      >
        <div className={cn('flex w-full flex-col items-center gap-4', contentClassName)}>{children}</div>
      </div>
    )
  },
)

FixedFooter.displayName = 'FixedFooter'
